// extracted by mini-css-extract-plugin
export default {"wrapper":"Section_wrapper__LSJNq","heading":"Section_heading__1rRBs","heading-title":"Section_heading-title__FbA9-","heading-divider":"Section_heading-divider__0bLC6"};